import React from "react";

// No tooltips added due to style positioning bug from fullscreening the modal
const View790AAddendumBColumns = ({
  toggleRemovalSelectAll,
  allRemovalSelected,
  removalSelectedIds,
  setRemovalSelectedIds,
}) => [
  {
    Header: ({ data }) => {
      return (
        <>
          <input
            id={`allRemovalListed`}
            className="usa-checkbox__input"
            type="checkbox"
            onChange={(e) => e}
            checked={allRemovalSelected}
            onClick={(e) => {
              toggleRemovalSelectAll();
            }}
          />
          <label
            className="usa-checkbox__label"
            style={{ margin: 0 }}
            htmlFor={`allRemovalListed`}
            onChange={(e) => e}
            checked={allRemovalSelected}
          />
        </>
      );
    },
    disableSortBy: true,
    id: "id",
    accessor: "crop_id",
    // fixedWidth: 65,
    fixedWidth: 40,

    Cell: ({ value, row: { original }, column: { id } }) => {
      const checked = removalSelectedIds?.includes(value);
      return (
        <>
          <input
            id={`remove_${value}`}
            className="usa-checkbox__input"
            type="checkbox"
            checked={checked}
            onChange={(e) => e}
            onClick={(e) => {
              if (e?.currentTarget?.checked) {
                setRemovalSelectedIds((prev = []) => [...prev, value]);
              } else {
                setRemovalSelectedIds(
                  removalSelectedIds.filter((id) => id !== value)
                );
              }
            }}
          />
          <label
            className="usa-checkbox__label"
            style={{
              margin: "2px 0 2px 2px",
            }}
            htmlFor={`remove_${value}`}
            onChange={(e) => e}
            checked={checked}
          />
        </>
      );
    },
  },
  {
    Header: "ID",
    id: "crop_id",
    accessor: (data) => data.crop_id,
    fixedWidth: 70,
    // centered: true,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
  },
  {
    Header: "Work State",
    id: "addmaCropState", // Dh's fieldname
    fixedWidth: 100,
    accessor: (data) => data.addmaCropState,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
  },
  {
    Header: "Crop or Agricultural Activity",
    id: "crop_name",
    accessor: (data) => data.crop_name,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
  },
  {
    Header: "Wage Offer",
    id: "wage_offer",
    fixedWidth: 120,
    accessor: (data) => data.wage_offer,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
  },
  {
    Header: "Wage Per",
    id: "wage_per",
    fixedWidth: 90,
    accessor: (data) => data.wage_per,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
  },
  {
    Header: "Piece Rate Offer",
    id: "addmaPieceRate",
    fixedWidth: 140,
    accessor: (data) => data.addmaPieceRate, // Dh's fieldname
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
  },
  {
    Header: "Additional Information",
    id: "additional_info",
    accessor: (data) => data.additional_info,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
  },
];

export default View790AAddendumBColumns;
